/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationSignpostRightIcon20Regular = forwardRef('LocationSignpostRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 1.5a.75.75 0 0 0-1.5 0V3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5.25v7.25a.75.75 0 0 0 1.5 0V11h4.065a2 2 0 0 0 1.435-.607l2.45-2.522a1.25 1.25 0 0 0 0-1.742l-2.45-2.522A2 2 0 0 0 14.815 3H10.75V1.5ZM4 4.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h10.815a.5.5 0 0 0 .359-.152L17.454 7l-2.28-2.348a.5.5 0 0 0-.359-.152H4Z" })));
});
